import { useDispatch } from 'react-redux';
import { useCookies } from 'react-cookie';
import { useHistory } from 'react-router';

import { setLogout } from 'actions/app.actions';
import { AUTH_COOKIE_KEY } from 'utils/useAuthToken';
import ROUTES from 'constants/routes';

type HookReturnType = () => void;

const useLogout = (): HookReturnType => {
  const dispatch = useDispatch();
  const [, , removeCookie] = useCookies([AUTH_COOKIE_KEY]);
  const history = useHistory();

  const logout = (): void => {
    dispatch(setLogout());
    removeCookie(AUTH_COOKIE_KEY, { path: ROUTES.HOME });
    // 2nd argument 'options' needed or removeCookie won't work:
    // https://github.com/reactivestack/cookies/issues/290
    window.location.href = '/logout';
  };

  return logout;
};

export default useLogout;
